import React, {useContext, useEffect} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import styles from './meter-zero.module.css';
import CommonMenu from '../../menu/commonMenu';
import SubMenuView from '../../views/subMenuView';
import ZeroVerification from './zero-verification';
import ZeroTime from './zero-calZeroTime';
import CommandsContext from '../../../context/commandsContext';

function ZeroCalibration({onExit}) {
  const zeroCalibrationItem = [
    {id: 1, name: 'Zero Verification', component: <ZeroVerification />},
    {id: 2, name: 'Zero Calibration', component: <ZeroTime />},
  ];

  const {selected, onComponent} = useMenu();
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands}));
  }, []);

  return (
    <SubMenuView
      title="Zero Calibration"
      menuItems={zeroCalibrationItem}
      content="IMPORTANT: Run Zero Verification before performing zero calibration."
      onLeftCallback={() => onExit()}
    />
  );
}

export default ZeroCalibration;
